import React from 'react';

function AppleIcon({ w, h, style, fill, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${w}px`}
      height={`${h}px`}
      viewBox="0 0 24 24"
      className={className}
      style={style}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M18.8596 9.1362C18.7552 9.2172 16.912 10.2558 16.912 12.5652C16.912 15.2364 19.2574 16.1814 19.3276 16.2048C19.3168 16.2624 18.955 17.499 18.091 18.759C17.3206 19.8678 16.516 20.9748 15.292 20.9748C14.068 20.9748 13.753 20.2638 12.34 20.2638C10.963 20.2638 10.4734 20.9982 9.35383 20.9982C8.23423 20.9982 7.45303 19.9722 6.55483 18.7122C5.51443 17.2326 4.67383 14.934 4.67383 12.7524C4.67383 9.2532 6.94903 7.3974 9.18823 7.3974C10.378 7.3974 11.3698 8.1786 12.1168 8.1786C12.8278 8.1786 13.9366 7.3506 15.2902 7.3506C15.8032 7.3506 17.6464 7.3974 18.8596 9.1362ZM14.6476 5.8692C15.2074 5.205 15.6034 4.2834 15.6034 3.3618C15.6034 3.234 15.5926 3.1044 15.5692 3C14.6584 3.0342 13.5748 3.6066 12.9214 4.3644C12.4084 4.9476 11.9296 5.8692 11.9296 6.8034C11.9296 6.9438 11.953 7.0842 11.9638 7.1292C12.0214 7.14 12.115 7.1526 12.2086 7.1526C13.0258 7.1526 14.0536 6.6054 14.6476 5.8692Z"
        fill={fill}
      />
    </svg>
  );
}

AppleIcon.defaultProps = {
  w: 24,
  h: 24,
  style: {},
  fill: '#000',
};

export default AppleIcon;
